<div id="global-loader" class="global-loader" *ngIf="isLoading">
  <div class="spinner"></div>
</div>
<div class="content-wrapper color-background" [class.active]="selectedCollection" [ngStyle]="{'height': scrHeight}">
  <!-- //left content -->
  <div class="left-panel" #dynamicDiv class="left-panel" [class.xyz]="selectedCollection">
    <div class="content">
      <div class="top-actions">

        <div class="header-collection">
          <div style="color:#cc0000">
            <label>Select Collection</label>
          </div>

          <!-- <div class="rightside">
            <button class="button-add add-text" (click)="openDialog()">
              <i class="material-icons">add</i>Add New</button>
          </div> -->
        </div>

        <div class="message-box" *ngIf="!isChecked"><mat-icon style="font-size:18px;color: #0d6efd;display: flex;align-items: center;">info</mat-icon>
          <span>Please select at least a collection to continue</span>
        </div>

        <div class="header2">
          <div class="search-container bg-1">
            <i class="material-icons">search</i>
            <input type="text" class="search-box bg-1" placeholder="Search collections..." [(ngModel)]="searchTermCollections"
              (input)="filterCollections()">
          </div>

          <!-- <mat-icon style="margin-top: 7px;color: #cc0000;">favorite</mat-icon> -->
          <span *ngIf="!isSmallScreen">
            <mat-icon style="margin-top:6px; cursor: pointer;color:#9ca3af ;font-size: 30px;"
              (click)="exportCollections()">download</mat-icon>
          </span>

          <button class="sort-text" (click)="toggleSort()">
            <span class="sort-arrows">
              <mat-icon class="arrow" [class.active]="sortDirection === 'asc'">north</mat-icon>
              <mat-icon class="arrow" [class.active]="sortDirection === 'desc'">south</mat-icon>
            </span>
          </button>
        </div>
      </div>


      <div class="grid">
        <div *ngFor="let collection of filteredCollections" class="card"
          [class.selected]="selectedCollection?.collection_id === collection.collection_id"
          (click)="selectCollection(collection)">
          <div class="card-content">
            <span class="card-text">{{ collection.collection_name }}</span>
            <span class="sub-collection-count">
              <mat-icon class="link-icon">link</mat-icon>
              {{ collection.sub_collections?.length || 0 }} sub collections
            </span>
          </div>
          <span class="star-icon" [class.star-filled]="collection.isFavorite"
            [matTooltip]="collection.isFavorite ? 'Remove from favorites' : 'Add to favorites'"
            (click)="toggleFavorite(collection); $event.stopPropagation()">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <!-- Rounded-outline star: stroke follows currentColor -->
              <path d="M12 17.27 L18.18 21 L16.54 13.97 L22 9.24 L14.81 8.63 L12 2 L9.19 8.63 L2 9.24 L7.46 13.97 L5.82 21 Z"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- right panel -->
  <div class="right-panel" >

    <div class="content">
      <div class="top-actions">

        <div class="header-collection" >
          <div style="color:#cc0000">
            <label>Select Sub-Collection</label>
          </div>
        </div>

        <div class="message-box" *ngIf="!isSubChecked"><mat-icon style="font-size:18px;color: #0d6efd;display: flex;align-items: center;padding-left: 5px;">info</mat-icon>
          <span>You can select multiple sub collections</span>
        </div>

        <div class="right-actions">
          <div class="search-container bg-1">
            <i class="material-icons">search</i>
            <input type="text" class="search-box bg-1" placeholder="Search sub-collections.." [(ngModel)]="searchTermSubCollections"
              (input)="filterSubCollections()">
          </div>
          <button class="sort-text" (click)=" toggleSortSubCollection()">
            <span class="sort-arrows">
              <mat-icon class="arrow" [class.active]="sortDirectionSubCollection === 'asc'">north</mat-icon>
              <mat-icon class="arrow" [class.active]="sortDirectionSubCollection === 'desc'">south</mat-icon>
            </span>
          </button>

        </div>
      </div>

      <div class="grid grid-subcollection" *ngIf="selectedCollection?.sub_collections.length > 0; else noSub">
        <div *ngFor="let sub of filteredSubCollections" class="card" [class.selected]="sub.isSelected"
          (click)="toggleSubCollectionSelection(sub) ; isSubChecked = true">
          <span class="card-text">{{ sub.sub_collection_name }}</span>
        </div>
      </div>
      <ng-template #noSub>
        <div class="grid nosub">
          <img class="no-data" src="assets/no-data.png">
          <p style="color: gray">No Data Found</p>
        </div>

      </ng-template>
    </div>
  </div>
</div>

<!-- Bootstrap Modal for Add Collection / Add Sub Collection -->
<div class="modal-backdrop show" *ngIf="showAddModal" (click)="cancelDialog()"></div>
<div class="modal d-flex show" *ngIf="showAddModal" (click)="$event.stopPropagation()">
  <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
    <div class="modal-content custom-dialog">
      <div class="modal-header border-0 p-0 d-flex justify-content-between align-items-center py-2">
        <h5 class="modal-title fs-6 fw-bold m-0">
          {{ selectedTabIndex === 0 ? 'Add New Collection' : 'Add New Sub Collection' }}
        </h5>
        <button type="button" class="close-btn" (click)="cancelDialog()" title="Cancel">✕</button>
      </div>
      
      <hr class="divider" />

      <div class="modal-body pt-0 px-0">
        <!-- Tabs -->
        <div class="tab-header">
          <button [class.active]="selectedTabIndex === 0" (click)="onTabChange(0)">Add Collection</button>
          <button [class.active]="selectedTabIndex === 1" (click)="onTabChange(1)">Add Sub Collection</button>
        </div>

        <!-- Add Collection Tab -->
        <div *ngIf="selectedTabIndex === 0">
          <!-- Collection Name -->
          <div class="form-group">
            <label>Collection Name <span class="required">*</span></label>
            <input class="expand-input" type="text" [(ngModel)]="newCollectionName" placeholder="Enter collection name"
              (input)="validateCollectionName(); validateForm()" />
            <span *ngIf="collectionExists" class="error-text collection-error">
              Collection already exists!
            </span>
          </div>

          <!-- Sub Collections -->
          <label class="sub-title">Sub Collections</label>

          <ng-container *ngFor="let sub of subCollectionArray; let i = index; trackBy: trackByIndex">
            <div class="form-group sub-collection">
              <div class="input-row">
                <input class="expand-input" type="text" [(ngModel)]="subCollectionArray[i].value"
                  placeholder="Enter sub collection name" (input)="validateSubCollectionName(i); validateForm()" />
                <span class="remove-icon" (click)="removeSubCollectionField(i)" title="Remove">✕</span>
              </div>

              <!-- Error under the input row -->
              <span *ngIf="subCollectionExists[i]" class="error-text">
                Sub-collection already exists!
              </span>
            </div>
          </ng-container>

          <a class="add-link" (click)="addSubCollectionField()">+ Add Another Sub-Collection</a>
        </div>

        <!-- Add Sub-Collection Tab -->
        <div *ngIf="selectedTabIndex === 1">
          <div class="form-group search-wrapper">
            <label>Search Existing Collection <span class="required">*</span></label>
            <div class="search-box">
              <i class="material-icons search-icon">search</i>
              <input type="text" [(ngModel)]="dialogSearchTerm" placeholder="Search collection" (input)="filterCollectionsDialog()"
                (keydown.enter)="$event.preventDefault()" />
            </div>
          </div>

          <div *ngIf="dialogSearchTerm.trim() !== ''">
            <div *ngFor="let collection of filteredCollectionsDialog" class="collection-card"
              (click)="selectCollection(collection)">
              <p class="collection-title">{{ collection.collection_name }}</p>
              <p class="collection-count">{{ collection.sub_collections.length }} sub-collections</p>
            </div>
          </div>

          <div *ngIf="selectedCollection" class="details-card">
            <p class="selected-label">Selected Collection: <strong>{{ selectedCollection.collection_name }}</strong></p>

            <label>Existing Sub-Collections</label>
            <div class="existing-sub-card">
              <ng-container *ngIf="selectedCollection.sub_collections?.length > 0; else noSubCollections">
                <ul>
                  <li *ngFor="let sub of selectedCollection.sub_collections">{{ sub.sub_collection_name }}</li>
                </ul>
              </ng-container>
              <ng-template #noSubCollections>
                <p class="no-sub">There is no sub-collection for this collection.</p>
              </ng-template>
            </div>

            <label class="sub-title">Add New Sub-Collection <span class="required">*</span></label>

            <ng-container *ngFor="let sub of newSubCollections; let i = index; trackBy: trackByIndex">
              <div class="form-group sub-collection">
                <div class="input-row">
                  <input type="text" [(ngModel)]="newSubCollections[i]" placeholder="Enter new sub-collection name"
                    (input)="validateSubCollectionName(i); validateForm()" />

                  <span *ngIf="i > 0" class="remove-icon" (click)="removeNewSubCollectionField(i)" title="Remove">✕</span>
                </div>

                <span *ngIf="subCollectionExists[i]" class="error-text">
                  Sub-collection already exists!
                </span>
              </div>
            </ng-container>

            <a class="add-link" (click)="addNewSubCollectionField()">+ Add Another Sub-Collection</a>
          </div>
        </div>
      </div>

      <hr class="divider" />

      <div class="modal-footer border-0 pt-0 px-0">
        <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelDialog()">Cancel</button>
        <button type="button" class="btn btn-danger" [disabled]="!isFormValid" (click)="saveSubCollection(selectedTabIndex)">Save</button>
      </div>
    </div>
  </div>
</div>
